<template>
    <!--<MenuSetting/>-->
    <el-container style="height: 100%;">
        <el-aside style="width: 180px;background-color: #2c2f35;">
            <img src="../assets/whitelogo.svg" class="img-icon"
                 style="width: 100px;height: 60px;padding:0 40px"/>
            <SideMenu/>
        </el-aside>
        <el-container style="min-width: 1000px">
            <el-header style="padding: 0 0;width: 100% ;background-color: #2c2f35">
            </el-header>
            <el-main style="padding: 0 0;width: 100%">
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    // import MenuSetting from '../pages/Menu'
    import SideMenu from '../components/SideMenu'

    export default {
        name: "Home",
        components: {
            // MenuSetting
            SideMenu
        }
    }
</script>

<style scoped>
    /*.logo-title {*/
    /*height: 60px;*/
    /*width: 180px;*/
    /*background-color: #2c2f35;*/
    /*}*/
    /*.logo-title-span{*/
    /*font-size:20px;*/
    /*color: white;*/
    /*height: 100%;*/
    /*}*/
</style>